var exports = {
  "k": "x61f99309--88d189--container",
  "X": "x61f99309--88d189--action",
};

module.exports = exports;
